import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { DeserializeVoid, _post } from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class SetAdjustmentNeedsPrintworkControllerRequestService {
  private readonly post: <T>(
    path: string,
    body: any,
    deserialize: (response: any) => T
  ) => Observable<T>;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      '/subprojects/setAdjustmentNeedsPrintwork',
      requestServices
    );
  }

  public setAdjustmentNeedsPrintwork(
    adjustmentId: number,
    needPrintwork: boolean,
    printworkExtraInfo: string | null,
    atelierExtraInfo: string | null,
    printStickerChecked: boolean,
    handleByAtelier: boolean,
    createNewBoard: boolean,
    subBoardsRequired: boolean
  ): Promise<void> {
    const requestBody: RequestBody = {
      adjustmentId,
      needPrintwork,
      printworkExtraInfo,
      atelierExtraInfo,
      printStickerChecked,
      handleByAtelier,
      createNewBoard,
      subBoardsRequired,
    };
    return this.post('', requestBody, DeserializeVoid).toPromise();
  }
}

interface RequestBody {
  adjustmentId: number;
  needPrintwork: boolean;
  printworkExtraInfo: string | null;
  atelierExtraInfo: string | null;
  printStickerChecked: boolean;
  handleByAtelier: boolean;
  createNewBoard: boolean;
  subBoardsRequired: boolean;
}
